import { useEffect, useState } from "react";
import api from "../api/api";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { useLocation } from "react-router-dom";

import {
    FaMapMarkerAlt,
    FaStar,
    FaStarHalfAlt,
    FaRegStar,
    FaSearch,
    FaUndo
} from "react-icons/fa";



export default function HotelList({
    limit,
    showViewAllButton = false,
    showSidebar = true,
    showBanner = false,
    showHeading = false   // ✅ ADD THIS
}) {

    const [hotels, setHotels] = useState([]);
    const [loading, setLoading] = useState(true);

    const location = useLocation();



    // Filters
    const [search, setSearch] = useState("");
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(5000);
    const [rating, setRating] = useState(0);

    const [destinations, setDestinations] = useState([]);
    const [selectedDestinations, setSelectedDestinations] = useState([]);

    const navigate = useNavigate();

    // Fetch Destinations
    const fetchDestinations = async () => {
        try {
            const response = await api.get("/destinations");
            setDestinations(response.data);
        } catch (err) {
            console.error("Error fetching destinations:", err);
        }
    };

    useEffect(() => {
        fetchDestinations();
    }, []);

    const handleDestinationChange = (dest) => {
        setSelectedDestinations((prev) =>
            prev.some(d => d.id === dest.id)
                ? prev.filter((d) => d.id !== dest.id)
                : [...prev, dest]
        );
    };

    // Debounce search
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => clearTimeout(handler);
    }, [search]);

    // Fetch Hotels
    const fetchHotels = async () => {
        setLoading(true);

        try {
            const response = await api.get("/hotels", {
                params: {
                    search: debouncedSearch,
                    destinations: selectedDestinations.map(d => d.id),
                    minPrice,
                    maxPrice,
                    rating,
                },
            });

            setHotels(response.data);
        } catch (err) {
            console.error("Error fetching hotels:", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchHotels();
    }, [debouncedSearch, minPrice, maxPrice, rating, selectedDestinations]);

    // Stars
    const renderStars = (ratingValue) => {
        return Array.from({ length: 5 }, (_, i) => {
            if (i < Math.floor(ratingValue)) return <FaStar key={i} />;
            if (i === Math.floor(ratingValue) && ratingValue % 1 >= 0.5)
                return <FaStarHalfAlt key={i} />;
            return <FaRegStar key={i} />;
        });
    };

    // Reset Filters
    const isFilterChanged =
        search !== "" ||
        minPrice !== 0 ||
        maxPrice !== 5000 ||
        rating !== 0 ||
        selectedDestinations.length > 0;

    const resetFilters = () => {
        setSearch("");
        setMinPrice(0);
        setMaxPrice(5000);
        setRating(0);
        setSelectedDestinations([]);
    };



    return (





        <div className="bg-slate-50 dark:bg-gray-950 min-h-screen">
            <PageHeader
                title="Available Hotels"
                subtitle={`${hotels.length} hotels found matching your search`}
            />
            {/* Heading */}

            {showHeading && (
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">

                    <div>
                        <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-50 text-[#FF6B35] text-sm font-semibold mb-4">
                            Hotel Collection
                        </span>

                        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white">
                            Find Your Perfect Stay
                        </h2>

                        <p className="text-slate-500 dark:text-gray-400 mt-3">
                            Browse luxury hotels, resorts and budget-friendly stays
                            across Dubai's most popular destinations.
                        </p>
                    </div>

                    <button
                        onClick={() => navigate("/hotels")}
                        className="hidden sm:flex items-center gap-2 px-6 py-3 bg-[#FF6B35] text-white rounded-xl hover:bg-orange-600 transition"
                    >
                        View All Hotels →
                    </button>

                </div>
            )}

            {/* Layout */}
            <div className="container mx-auto px-6 py-24 space-y-10">
                <div className="w-full space-y-6">
                    {/* Sidebar */}
                    {showSidebar && (
                        <div className="w-full">
                            <div className="
        lg:sticky lg:top-28
        bg-white dark:bg-gray-900
        rounded-2xl
        border border-gray-200 dark:border-gray-800
        shadow-md
        p-4
    ">

                                <div className="
            flex flex-col gap-3
            sm:grid sm:grid-cols-2
            lg:flex lg:flex-row
            lg:items-center
            lg:gap-3
        ">

                                    {/* Search */}
                                    <div className="
                flex items-center gap-2
                bg-gray-100 dark:bg-gray-800
                px-3 py-2 rounded-xl
                w-full
            ">
                                        <FaSearch className="text-[#FF6B35]" />
                                        <input
                                            type="text"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            placeholder="Search hotel..."
                                            className="bg-transparent outline-none w-full text-sm text-gray-800 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400"
                                        />
                                    </div>

                                    {/* Min Price */}
                                    <input
                                        type="number"
                                        value={minPrice}
                                        onChange={(e) => setMinPrice(e.target.value)}
                                        placeholder="Min"
                                        className="
                    w-full sm:w-auto lg:w-24
                    px-3 py-2 rounded-xl
                    border border-gray-200 dark:border-gray-700
                    bg-white dark:bg-gray-800
                    text-gray-800 dark:text-gray-100
                    placeholder-gray-400 text-sm
                    focus:ring-2 focus:ring-[#FF6B35]
                "
                                    />

                                    {/* Max Price */}
                                    <input
                                        type="number"
                                        value={maxPrice}
                                        onChange={(e) => setMaxPrice(e.target.value)}
                                        placeholder="Max"
                                        className="
                    w-full sm:w-auto lg:w-24
                    px-3 py-2 rounded-xl
                    border border-gray-200 dark:border-gray-700
                    bg-white dark:bg-gray-800
                    text-gray-800 dark:text-gray-100
                    placeholder-gray-400 text-sm
                    focus:ring-2 focus:ring-[#FF6B35]
                "
                                    />

                                    {/* Rating */}
                                    <select
                                        value={rating}
                                        onChange={(e) => setRating(e.target.value)}
                                        className="
                    w-full sm:w-auto
                    px-3 py-2 rounded-xl
                    border border-gray-200 dark:border-gray-700
                    bg-white dark:bg-gray-800
                    text-gray-800 dark:text-gray-100 text-sm
                    focus:ring-2 focus:ring-[#FF6B35]
                "
                                    >
                                        <option value="0">All Ratings</option>
                                        <option value="3">3★ & above</option>
                                        <option value="4">4★ & above</option>
                                        <option value="4.5">4.5★ & above</option>
                                    </select>

                                    {/* Destinations */}
                                    <select
                                        className="
                    w-full sm:w-auto
                    px-3 py-2 rounded-xl
                    border border-gray-200 dark:border-gray-700
                    bg-white dark:bg-gray-800
                    text-gray-800 dark:text-gray-100 text-sm
                    focus:ring-2 focus:ring-[#FF6B35]
                "
                                        onChange={(e) => {
                                            const dest = destinations.find(d => d.id == e.target.value);
                                            if (dest) handleDestinationChange(dest);
                                        }}
                                    >
                                        <option value="">Destinations</option>
                                        {destinations.map(dest => (
                                            <option key={dest.id} value={dest.id}>
                                                {dest.name}
                                            </option>
                                        ))}
                                    </select>

                                    {/* Reset */}
                                    {isFilterChanged && (
                                        <button
                                            onClick={resetFilters}
                                            className="
                        w-full sm:w-auto
                        flex items-center justify-center gap-2
                        px-4 py-2 rounded-xl
                        bg-orange-500 text-white text-sm
                        hover:bg-orange-600 transition
                    "
                                        >
                                            <FaUndo />
                                            Reset
                                        </button>
                                    )}

                                </div>
                            </div>
                        </div>
                    )}

                    {/* Hotels */}
                    <div className="w-full">

                        {/* Top Bar */}
                        {location.pathname === "/hotels" && (
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
                                <div>
                                    <h2 className="text-3xl font-bold text-slate-900 dark:text-white">
                                        Showing
                                        <span className="text-[#FF6B35]"> {hotels.length} </span>
                                        Hotels
                                    </h2>

                                    <p className="text-slate-500 mt-1">
                                        Discover luxury stays across Dubai
                                    </p>
                                </div>
                            </div>
                        )}

                        {loading ? (
                            <div className="flex flex-col items-center justify-center py-28 text-center">

                                <div className="relative w-24 h-24 mb-6">

                                    <div className="absolute inset-0 rounded-full border-4 border-blue-100 dark:border-blue-900"></div>

                                    <div className="absolute inset-0 rounded-full border-4 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>

                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <div className="w-10 h-10 bg-blue-500 rounded-lg animate-pulse"></div>
                                    </div>

                                </div>

                                <h3 className="text-lg font-semibold text-gray-700 dark:text-white">
                                    Searching the best hotels
                                </h3>

                                <p className="text-gray-500 dark:text-gray-400 mt-2">
                                    Finding perfect stays for your destination...
                                </p>

                                <div className="flex gap-1 mt-4">
                                    <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></span>
                                    <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0.1s]"></span>
                                    <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0.2s]"></span>
                                </div>

                            </div>
                        ) : (
                            <>
                                <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                                    {(limit ? hotels.slice(0, limit) : hotels).map((hotel) => (
                                        <div
                                            key={hotel.id}
                                            onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                            className="group bg-white dark:bg-gray-900 rounded-2xl overflow-hidden 
    shadow-md hover:shadow-2xl transition-all duration-300 
    cursor-pointer border border-gray-100 dark:border-gray-800
    hover:-translate-y-1"
                                        >

                                            {/* Image */}
                                            <div className="relative h-52 overflow-hidden">

                                                <img
                                                    src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                                    alt={hotel.name}
                                                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                                                />

                                                {/* Rating Badge (ONLY ONE BADGE) */}
                                                <div className="absolute top-3 right-3 bg-white/90 dark:bg-gray-800/90 backdrop-blur px-3 py-1 rounded-full text-xs font-semibold shadow flex items-center gap-1">
                                                    ⭐ {hotel.rating || "4.5"}
                                                </div>

                                                {/* Optional: Popular badge (only if high rating) */}
                                                {hotel.rating >= 4.5 && (
                                                    <div className="absolute top-3 left-3 bg-green-600 text-white text-xs px-3 py-1 rounded-full font-semibold shadow">
                                                        Popular Choice
                                                    </div>
                                                )}

                                                {/* Soft overlay */}
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                                            </div>

                                            {/* Content */}
                                            <div className="p-4">

                                                {/* Title */}
                                                <h3 className="font-bold text-gray-800 dark:text-white text-lg line-clamp-1 group-hover:text-blue-600 transition">
                                                    {hotel.name}
                                                </h3>

                                                {/* Location */}
                                                <p className="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1 mt-1">
                                                    <FaMapMarkerAlt />
                                                    {hotel.location || hotel.city || "Dubai, UAE"}
                                                </p>

                                                {/* Description */}
                                                <p className="text-sm text-gray-600 dark:text-gray-300 mt-3 line-clamp-2 min-h-[42px]">
                                                    {hotel.short_description?.replace(/<[^>]*>/g, "")}
                                                </p>

                                                {/* Amenities (DYNAMIC if available) */}
                                                <div className="flex flex-wrap gap-2 text-xs text-gray-500 dark:text-gray-400 mt-4">
                                                    {(hotel.amenities?.slice(0, 3) || []).map((item, i) => (
                                                        <span
                                                            key={i}
                                                            className="bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded-full"
                                                        >
                                                            {item}
                                                        </span>
                                                    ))}
                                                </div>

                                                {/* Bottom section */}
                                                <div className="flex items-center justify-between mt-5">

                                                    <div>
                                                        <p className="text-blue-600 font-bold text-xl">
                                                            AED {Math.round(hotel.price_per_night)}
                                                        </p>
                                                        <span className="text-xs text-gray-400 dark:text-gray-500">
                                                            per night
                                                        </span>
                                                    </div>

                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            navigate(`/hotels/${hotel.slug}`);
                                                        }}
                                                        className="px-4 py-2 rounded-lg 
                bg-gradient-to-r from-blue-500 to-cyan-500 
                text-white text-sm font-medium
                shadow-md hover:shadow-xl
                transition-all duration-300
                hover:-translate-y-1 hover:scale-105 active:scale-95"
                                                    >
                                                        View Deal →
                                                    </button>

                                                </div>

                                            </div>

                                        </div>
                                    ))}
                                </div>

                                {/* Mobile View All Button */}
                                {showHeading && (
                                    <div className="mt-8 sm:hidden">
                                        <button
                                            onClick={() => navigate("/hotels")}
                                            className="w-full bg-[#FF6B35] text-white px-5 py-3 rounded-xl hover:bg-orange-600 transition text-sm font-medium"
                                        >
                                            View All
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>

    );
}